import api from '@/services/api';

/**
 * Create a new Company
 * @param {Company} Company to create
 * @returns {Promise} Company created
 */
function createCompany(company) {
  return api().post('companies', { ...company });
}

/**
 *
 * @param {Object} company to be updated
 * @param {Number} companyId to be updated
 * @returns {Promise} company updated
 */
function updateCompany(company, companyId) {
  return api().put(`companies/${companyId}`, { ...company });
}

/**
 * Find all conventions
 * @returns {Promise} list fetched
 */
function findAllConventions(name) {
  return api().get(`conventions/${name}`);
}

/**
 * Retrieve a company from an UUID
 * @param {UUID} Company UUID to fetch
 * @returns {Promise} Company fetched
 */
function getCompany(companyId) {
  return api().get(`companies/${companyId}`);
}

/**
  * Find all invoices attached to a company
  * @param {*} companyId
  * @returns a list of invoices
  */
function findInvoicesByCompanyId(companyId) {
  return api().get(`companies/${companyId}/invoices`);
}

/**
   * Find all transactions attached to a company
   * @param {String} companyId
   * @returns a list of transactions
   */
function findAllTransactionsByCompanyId(companyId) {
  return api().get(`companies/${companyId}/transactions`);
}

function getSponsorshipsFromCompany(companyId) {
  return api().get(`companies/${companyId}/sponsorships`);
}

function addSponsorshipsToCompany(companyId, sponsorships) {
  return api().put(`companies/${companyId}/sponsorships`, { sponsorships });
}

function updateLogo(formData, id) {
  return api().put(`companies/${id}/logo`, formData);
}

function createStripeReference(id) {
  return api().post(`companies/${id}/external_payment_system_reference`);
}

function findAllSubscriptionsByCompanyId(companyId) {
  return api().get(`companies/${companyId}/subscriptions?perPage=1000`);
}

function findPendingPaymentsFromCompanyId(companyId) {
  return api().get(`companies/${companyId}/payments?filters=status:eq:PENDING`);
}

function findAllMembersByCompanyId(companyId) {
  return api().get(`companies/${companyId}/accounts`);
}

function getCompanyFromApiSireneId(apiCompanyId) {
  return api().get(`sirene/${apiCompanyId}`);
}

function findAllEmployeesByCompanyId(companyId) {
  return api().get(`companies/${companyId}/employees`);
}

function findAllCountries() {
  return api().get('countries?perPage=1000&sort=name');
}

export {
  getCompany,
  findAllConventions,
  createCompany,
  updateCompany,
  updateLogo,
  findInvoicesByCompanyId,
  createStripeReference,
  getSponsorshipsFromCompany,
  addSponsorshipsToCompany,
  findAllTransactionsByCompanyId,
  findAllSubscriptionsByCompanyId,
  findPendingPaymentsFromCompanyId,
  findAllMembersByCompanyId,
  getCompanyFromApiSireneId,
  findAllEmployeesByCompanyId,
  findAllCountries,
};
